import { render, staticRenderFns } from "./SvgPlay.vue?vue&type=template&id=0db84311&"
import script from "./SvgPlay.vue?vue&type=script&lang=js&"
export * from "./SvgPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports